// Official emergency numbers for popular countries.
// Sources: each country's official emergency services portal.
// fields: police, fire, ambulance, general (single-number EU style); notes live in the i18n locales

export const EMERGENCY_COUNTRIES = [
  {
    code: "NO",
    name: "Norway",
    flag: "🇳🇴",
    general: "112",
    police: "112",
    fire: "110",
    ambulance: "113",
  },
  {
    code: "SE",
    name: "Sweden",
    flag: "🇸🇪",
    general: "112",
    police: "112",
    fire: "112",
    ambulance: "112",
  },
  {
    code: "FI",
    name: "Finland",
    flag: "🇫🇮",
    general: "112",
    police: "112",
    fire: "112",
    ambulance: "112",
  },
  {
    code: "DK",
    name: "Denmark",
    flag: "🇩🇰",
    general: "112",
    police: "114",
    fire: "112",
    ambulance: "112",
  },
  {
    code: "IS",
    name: "Iceland",
    flag: "🇮🇸",
    general: "112",
    police: "112",
    fire: "112",
    ambulance: "112",
  },
  {
    code: "DE",
    name: "Germany",
    flag: "🇩🇪",
    general: "112",
    police: "110",
    fire: "112",
    ambulance: "112",
  },
  {
    code: "FR",
    name: "France",
    flag: "🇫🇷",
    general: "112",
    police: "17",
    fire: "18",
    ambulance: "15",
  },
  {
    code: "GB",
    name: "United Kingdom",
    flag: "🇬🇧",
    general: "999",
    police: "999",
    fire: "999",
    ambulance: "999",
  },
  {
    code: "IE",
    name: "Ireland",
    flag: "🇮🇪",
    general: "112",
    police: "999",
    fire: "999",
    ambulance: "999",
  },
  {
    code: "NL",
    name: "Netherlands",
    flag: "🇳🇱",
    general: "112",
    police: "0900-8844",
    fire: "112",
    ambulance: "112",
  },
  {
    code: "ES",
    name: "Spain",
    flag: "🇪🇸",
    general: "112",
    police: "091",
    fire: "080",
    ambulance: "061",
  },
  {
    code: "IT",
    name: "Italy",
    flag: "🇮🇹",
    general: "112",
    police: "113",
    fire: "115",
    ambulance: "118",
  },
  {
    code: "PL",
    name: "Poland",
    flag: "🇵🇱",
    general: "112",
    police: "997",
    fire: "998",
    ambulance: "999",
  },
  {
    code: "US",
    name: "United States",
    flag: "🇺🇸",
    general: "911",
    police: "911",
    fire: "911",
    ambulance: "911",
  },
  {
    code: "CA",
    name: "Canada",
    flag: "🇨🇦",
    general: "911",
    police: "911",
    fire: "911",
    ambulance: "911",
  },
  {
    code: "AU",
    name: "Australia",
    flag: "🇦🇺",
    general: "000",
    police: "000",
    fire: "000",
    ambulance: "000",
  },
  {
    code: "NZ",
    name: "New Zealand",
    flag: "🇳🇿",
    general: "111",
    police: "111",
    fire: "111",
    ambulance: "111",
  },
  {
    code: "CN",
    name: "China",
    flag: "🇨🇳",
    general: null,
    police: "110",
    fire: "119",
    ambulance: "120",
  },
  {
    code: "RU",
    name: "Russia",
    flag: "🇷🇺",
    general: "112",
    police: "102",
    fire: "101",
    ambulance: "103",
  },
  {
    code: "TH",
    name: "Thailand",
    flag: "🇹🇭",
    general: null,
    police: "191",
    fire: "199",
    ambulance: "1669",
  },
];
